<div
  [class]="{
    'container-prod': isProd,
    'container-dev': !isProd
  }"
>
  <div nz-row></div>
  <div class="top">
    <!-- <a href="#" target="_blank"> -->
    <img class="logo" src="assets/img/logo.png" alt="CRM Condor" />
    <span class="title">{{ appName }}</span>
    <!-- </a> -->
  </div>
  <div class="form">
    <nz-card class="card">
      <form nz-form [formGroup]="loginForm">
        <nz-form-item>
          <nz-form-control nzErrorTip="Please enter a valid email">
            <nz-input-group nzPrefixIcon="user" nzSize="large">
              <input
                type="text"
                nz-input
                formControlName="email"
                placeholder="Email"
                autocomplete="Email"
              />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-control nzErrorTip="Please enter a valid password">
            <nz-input-group
              [nzSuffix]="suffixTemplate"
              nzPrefixIcon="lock"
              nzSize="large"
            >
              <input
                [type]="passwordVisible ? 'text' : 'password'"
                nz-input
                placeholder="Password"
                formControlName="pwd"
              />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <nz-icon
                class="ant-input-password-icon"
                [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"
              />
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-control>
            <label nz-checkbox formControlName="remember">
              <span style="color: white">Remember</span>
            </label>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-control style="text-align: center">
            <button
              nz-button
              [class]="{
                'login-form-button-prod': isProd,
                'login-form-button': !isProd
              }"
              nzType="default"
              nzSize="large"
              nzShape="round"
              [nzLoading]="isLoading"
              [disabled]="disableLogin()"
              (click)="onLogin()"
            >
              Log In
            </button>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control style="text-align: center">
            <button
              class="sing-up-button"
              nz-button
              nzType="default"
              nzSize="large"
              nzShape="round"
              (click)="onSignUp()"
            >
              Sign Up
            </button>
          </nz-form-control>
        </nz-form-item>
        <!-- <a
          routerLink="/forgot-password"
          [ngClass]="{
            'forgot-password-dev': !isProd,
            'forgot-password-prod': isProd
          }"
        >
          Forgot Password?</a -->
      </form>
    </nz-card>
  </div>
</div>
